var React = require('react');

function OvalMobile (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M100 93V8A174 174 0 0 0 0 8v85c33-6.6 67-6.6 100 0z"}));
}

OvalMobile.defaultProps = {"viewBox":"0 0 100 100","preserveAspectRatio":"none"};

module.exports = OvalMobile;

OvalMobile.default = OvalMobile;
